// // // // // // // // // import React, { useState } from "react";
// // // // // // // // // import Tabs from "@mui/material/Tabs";
// // // // // // // // // import Tab from "@mui/material/Tab";
// // // // // // // // // import Box from "@mui/material/Box";
// // // // // // // // // import Grid from "@mui/material/Grid";
// // // // // // // // // import { Field } from "formik";

// // // // // // // // // const tabData = {
// // // // // // // // //     Dashboard: ["Dashboard"],
// // // // // // // // //     OperatorRegistration: ["All User List", "Purchaser List", "Referrer List", "Financial Consultant List"],
// // // // // // // // //     SchemeManagement: ["Gold Stake Schemes", "Referral Schemes"],
// // // // // // // // //     ContentManagement: [
// // // // // // // // //         {
// // // // // // // // //             title: "Home",
// // // // // // // // //             subHeadings: [
// // // // // // // // //                 { items: ["Banner"] },
// // // // // // // // //                 { name: "Offers", items: ["Heading", "Card Design"] },
// // // // // // // // //                 { items: ["Refferals"] },
// // // // // // // // //                 { name: "Mobile", items: ["Heading", "Card Design"] },
// // // // // // // // //             ]
// // // // // // // // //         },
// // // // // // // // //         {
// // // // // // // // //             title: "Stake Now",
// // // // // // // // //             subHeadings: ["Heading", "Card Design"],
// // // // // // // // //         },
// // // // // // // // //         {
// // // // // // // // //             title: "About Us",
// // // // // // // // //             subHeadings: [
// // // // // // // // //                 { items: ["Banner"] },
// // // // // // // // //                 { name: "Offers", items: ["Heading", "Card Design"] },
// // // // // // // // //                 { items: ["Refferals"] },
// // // // // // // // //                 { name: "Mobile", items: ["Heading", "Card Design"] },
// // // // // // // // //             ]
// // // // // // // // //         },
// // // // // // // // //         {
// // // // // // // // //             title: "Blog",
// // // // // // // // //             subHeadings: [
// // // // // // // // //                 { items: ["Banner"] },
// // // // // // // // //                 { name: "Offers", items: ["Heading", "Card Design"] },
// // // // // // // // //                 { items: ["Refferals"] },
// // // // // // // // //                 { name: "Mobile", items: ["Heading", "Card Design"] },
// // // // // // // // //             ]
// // // // // // // // //         },
// // // // // // // // //         {
// // // // // // // // //             title: "Contact Us",
// // // // // // // // //             subHeadings: [
// // // // // // // // //                 { items: ["Banner"] },
// // // // // // // // //                 { name: "Offers", items: ["Heading", "Card Design"] },
// // // // // // // // //                 { items: ["Refferals"] },
// // // // // // // // //                 { name: "Mobile", items: ["Heading", "Card Design"] },
// // // // // // // // //             ]
// // // // // // // // //         },
// // // // // // // // //     ],
// // // // // // // // // };

// // // // // // // // // const UserRoleTab = ({ values, setFieldValue }) => {
// // // // // // // // //     const [activeTab, setActiveTab] = useState(0);
// // // // // // // // //     const [expandedHeading, setExpandedHeading] = useState(null);

// // // // // // // // //     const handleTabChange = (event, newValue) => {
// // // // // // // // //         setActiveTab(newValue);
// // // // // // // // //     };

// // // // // // // // //     const handleHeadingClick = (heading) => {
// // // // // // // // //         setExpandedHeading(expandedHeading === heading ? null : heading);
// // // // // // // // //     };

// // // // // // // // //     return (
// // // // // // // // //         <Box sx={{ width: "100%" }}>
// // // // // // // // //             <Box
// // // // // // // // //                 sx={{
// // // // // // // // //                     maxWidth: { xs: 320, sm: "100%", md: "100%" },
// // // // // // // // //                     boxShadow: 2,
// // // // // // // // //                     bgcolor: "background.paper",
// // // // // // // // //                     color: "#C38F51",
// // // // // // // // //                 }}
// // // // // // // // //             >
// // // // // // // // //                 <Tabs
// // // // // // // // //                     value={activeTab}
// // // // // // // // //                     onChange={handleTabChange}
// // // // // // // // //                     variant="scrollable"
// // // // // // // // //                     scrollButtons
// // // // // // // // //                     allowScrollButtonsMobile
// // // // // // // // //                     aria-label="user role tabs"
// // // // // // // // //                     sx={{
// // // // // // // // //                         ".MuiButtonBase-root-MuiTab-root.Mui-selected": { color: "#C38F51" },
// // // // // // // // //                     }}
// // // // // // // // //                     TabIndicatorProps={{
// // // // // // // // //                         style: {
// // // // // // // // //                             backgroundColor: "#C38F51",
// // // // // // // // //                             height: "3px",
// // // // // // // // //                         },
// // // // // // // // //                     }}
// // // // // // // // //                 >
// // // // // // // // //                     {Object.keys(tabData).map((tab, index) => (
// // // // // // // // //                         <Tab
// // // // // // // // //                             key={tab}
// // // // // // // // //                             label={tab}
// // // // // // // // //                             sx={{
// // // // // // // // //                                 fontSize: "16px",
// // // // // // // // //                                 color: activeTab === index ? "#C38F51" : "black",
// // // // // // // // //                                 textTransform: "none",
// // // // // // // // //                                 fontWeight: activeTab === index ? "bold" : "normal",
// // // // // // // // //                                 borderBottom: activeTab === index ? "3px solid #C38F51" : "none",
// // // // // // // // //                                 "&:hover": { color: "#C38F51" },
// // // // // // // // //                             }}
// // // // // // // // //                         />
// // // // // // // // //                     ))}
// // // // // // // // //                 </Tabs>
// // // // // // // // //             </Box>

// // // // // // // // //             <Box>
// // // // // // // // //                 {Object.keys(tabData).map((tab, index) =>
// // // // // // // // //                     index === activeTab ? (
// // // // // // // // //                         <Box key={tab}>
// // // // // // // // //                             {/* Title row */}
// // // // // // // // //                             <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
// // // // // // // // //                                 <Grid item xs={4} md={6}>
// // // // // // // // //                                     <h4>Permissions</h4>
// // // // // // // // //                                 </Grid>
// // // // // // // // //                                 <Grid item xs={8} md={6}>
// // // // // // // // //                                     <Grid container justifyContent="space-between" spacing={2}>
// // // // // // // // //                                         {["Add", "Edit", "Delete", "View"].map((action) => (
// // // // // // // // //                                             <Grid item key={action}>
// // // // // // // // //                                                 <strong>{action}</strong>
// // // // // // // // //                                             </Grid>
// // // // // // // // //                                         ))}
// // // // // // // // //                                     </Grid>
// // // // // // // // //                                 </Grid>
// // // // // // // // //                             </Grid>

// // // // // // // // //                             {/* Tab data */}
// // // // // // // // //                             {tabData[tab].map((item) =>
// // // // // // // // //                                 typeof item === "string" ? (
// // // // // // // // //                                     <Grid container spacing={2} key={item} alignItems="center">
// // // // // // // // //                                         <Grid item xs={4} md={6}>
// // // // // // // // //                                             <h4>{item}</h4>
// // // // // // // // //                                         </Grid>
// // // // // // // // //                                         <Grid item xs={8} md={6}>
// // // // // // // // //                                             <Grid container justifyContent="space-between" spacing={2}>
// // // // // // // // //                                                 {["add", "edit", "delete", "view"].map((action) => (
// // // // // // // // //                                                     <Grid item key={action}>
// // // // // // // // //                                                         <label>
// // // // // // // // //                                                             <Field
// // // // // // // // //                                                                 type="checkbox"
// // // // // // // // //                                                                 name={`permissions.${tab}.${item}.${action}`}
// // // // // // // // //                                                                 style={{
// // // // // // // // //                                                                     transform: "scale(1.2)", // For larger checkboxes
// // // // // // // // //                                                                     margin: "0 5px",
// // // // // // // // //                                                                 }}
// // // // // // // // //                                                             />
// // // // // // // // //                                                         </label>
// // // // // // // // //                                                     </Grid>
// // // // // // // // //                                                 ))}
// // // // // // // // //                                             </Grid>
// // // // // // // // //                                         </Grid>
// // // // // // // // //                                     </Grid>
// // // // // // // // //                                 ) : (
// // // // // // // // //                                     <Box key={item.title} sx={{ display: "flex", flexDirection: "row" }}>
// // // // // // // // //                                         <Grid xs={4}>
// // // // // // // // //                                             <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
// // // // // // // // //                                                 <Grid item xs={4}>
// // // // // // // // //                                                     <h4
// // // // // // // // //                                                         style={{ cursor: "pointer" }}
// // // // // // // // //                                                         onClick={() => handleHeadingClick(item.title)}
// // // // // // // // //                                                     >
// // // // // // // // //                                                         {item.title}
// // // // // // // // //                                                     </h4>
// // // // // // // // //                                                 </Grid>
// // // // // // // // //                                             </Grid>
// // // // // // // // //                                         </Grid>

// // // // // // // // //                                         {/* Show subheadings only if this heading is expanded */}
// // // // // // // // //                                         <Grid item xs={8}>
// // // // // // // // //                                             {expandedHeading === item.title &&
// // // // // // // // //                                                 item.subHeadings.map((subItem, idx) => {
// // // // // // // // //                                                     // Check if subItem is an object (with 'items' or 'name')
// // // // // // // // //                                                     if (typeof subItem === "object") {
// // // // // // // // //                                                         return (
// // // // // // // // //                                                             <Grid
// // // // // // // // //                                                                 container
// // // // // // // // //                                                                 spacing={2}
// // // // // // // // //                                                                 key={idx}
// // // // // // // // //                                                                 flexDirection="column"
// // // // // // // // //                                                                 alignItems="center"
// // // // // // // // //                                                                 sx={{ mb: 1 }}
// // // // // // // // //                                                             >
// // // // // // // // //                                                                 {subItem.name && (
// // // // // // // // //                                                                     <Grid item xs={3} md={2}>
// // // // // // // // //                                                                         <h5>{subItem.name || "Subheading"}</h5> {/* Display subheading */}
// // // // // // // // //                                                                     </Grid>)}                                                               {/* Render each item in four fields */}
// // // // // // // // //                                                                 <Grid item xs={9} md={6}>
// // // // // // // // //                                                                     <Grid container spacing={2}>

// // // // // // // // //                                                                         {subItem.items?.map((subItemAction, subIdx) => (
// // // // // // // // //                                                                             <>
// // // // // // // // //                                                                                 <Grid item key={subIdx}>
// // // // // // // // //                                                                                     {subItemAction}
// // // // // // // // //                                                                                 </Grid>

// // // // // // // // //                                                                                 {["add", "edit", "delete", "view"].map((action) => (
// // // // // // // // //                                                                                     <Grid item key={action}>
// // // // // // // // //                                                                                         <label>
// // // // // // // // //                                                                                             <Field
// // // // // // // // //                                                                                                 type="checkbox"
// // // // // // // // //                                                                                                 name={`permissions.${tab}.${item}.${action}`}
// // // // // // // // //                                                                                                 style={{
// // // // // // // // //                                                                                                     transform: "scale(1.2)", // For larger checkboxes
// // // // // // // // //                                                                                                     margin: "0 5px",
// // // // // // // // //                                                                                                 }}
// // // // // // // // //                                                                                             />
// // // // // // // // //                                                                                         </label>
// // // // // // // // //                                                                                     </Grid>
// // // // // // // // //                                                                                 ))}

// // // // // // // // //                                                                             </>
// // // // // // // // //                                                                         ))}
// // // // // // // // //                                                                     </Grid>
// // // // // // // // //                                                                 </Grid>
// // // // // // // // //                                                             </Grid>
// // // // // // // // //                                                         );
// // // // // // // // //                                                     } else {
// // // // // // // // //                                                         return (
// // // // // // // // //                                                             <Grid
// // // // // // // // //                                                                 container
// // // // // // // // //                                                                 spacing={2}
// // // // // // // // //                                                                 key={idx}
// // // // // // // // //                                                                 flexDirection="row"
// // // // // // // // //                                                                 alignItems="center"
// // // // // // // // //                                                                 sx={{ mb: 1 }}
// // // // // // // // //                                                             >
// // // // // // // // //                                                                 <Grid item xs={3} md={2}>
// // // // // // // // //                                                                     <h5>{subItem}</h5> {/* Display string subheading */}
// // // // // // // // //                                                                 </Grid>
// // // // // // // // //                                                                 <Grid item xs={9} md={6}>
// // // // // // // // //                                                                     <Grid container spacing={2}>
// // // // // // // // //                                                                         {["add", "edit", "delete", "view"].map((action) => (
// // // // // // // // //                                                                             <Grid item xs={3} key={action}>
// // // // // // // // //                                                                                 <label>
// // // // // // // // //                                                                                     <Field
// // // // // // // // //                                                                                         type="checkbox"
// // // // // // // // //                                                                                         name={`permissions.${tab}.${item.title}.${subItem}.${action}`}
// // // // // // // // //                                                                                         style={{
// // // // // // // // //                                                                                             transform: "scale(1.2)", // For larger checkboxes
// // // // // // // // //                                                                                             margin: "0 5px",
// // // // // // // // //                                                                                         }}
// // // // // // // // //                                                                                     />
// // // // // // // // //                                                                                 </label>
// // // // // // // // //                                                                                 <div>{action}</div> {/* Display the action */}
// // // // // // // // //                                                                             </Grid>
// // // // // // // // //                                                                         ))}
// // // // // // // // //                                                                     </Grid>
// // // // // // // // //                                                                 </Grid>
// // // // // // // // //                                                             </Grid>
// // // // // // // // //                                                         );
// // // // // // // // //                                                     }
// // // // // // // // //                                                 })}
// // // // // // // // //                                         </Grid>
// // // // // // // // //                                     </Box>
// // // // // // // // //                                 )
// // // // // // // // //                             )}
// // // // // // // // //                         </Box>
// // // // // // // // //                     ) : null
// // // // // // // // //                 )}
// // // // // // // // //             </Box>
// // // // // // // // //         </Box>
// // // // // // // // //     );
// // // // // // // // // };

// // // // // // // // // export default UserRoleTab;

// // // // // // // // import React, { useState } from 'react';
// // // // // // // // import Tabs from '@mui/material/Tabs';
// // // // // // // // import Tab from '@mui/material/Tab';
// // // // // // // // import Box from '@mui/material/Box';
// // // // // // // // import { Field } from 'formik';

// // // // // // // // const tabData = {
// // // // // // // //     Dashboard: ["Dashboard"],
// // // // // // // //     OperatorRegistration: ["All User List", "Purchaser List", "Referrer List", "Financial Consultant List"],
// // // // // // // //     SchemeManagement: ["Gold Stake Schemes", "Referral Schemes"],
// // // // // // // //     ContentManagement: ["Home", "Stake Now", "About Us", "Blog", "Contact Us"],
// // // // // // // // };

// // // // // // // // const UserRoleTab = ({ values, setFieldValue }) => {
// // // // // // // //     const [activeTab, setActiveTab] = useState(0);

// // // // // // // //     const handleTabChange = (event, newValue) => {
// // // // // // // //         setActiveTab(newValue);
// // // // // // // //     };

// // // // // // // //     return (
// // // // // // // //         <div>
// // // // // // // //             <Box
// // // // // // // //                 sx={{
// // // // // // // //                     maxWidth: { xs: 320, sm: "100%", md: "100%" },
// // // // // // // //                     boxShadow: 2,
// // // // // // // //                     bgcolor: 'background.paper',
// // // // // // // //                     color: "#C38F51",
// // // // // // // //                 }}
// // // // // // // //             >
// // // // // // // //                 <Tabs
// // // // // // // //                     value={activeTab}
// // // // // // // //                     onChange={handleTabChange}
// // // // // // // //                     variant="scrollable"
// // // // // // // //                     scrollButtons
// // // // // // // //                     allowScrollButtonsMobile
// // // // // // // //                     aria-label="user role tabs"
// // // // // // // //                     sx={{
// // // // // // // //                         '.MuiButtonBase-root-MuiTab-root.Mui-selected': { color: "#C38F51" },
// // // // // // // //                     }}
// // // // // // // //                     TabIndicatorProps={{
// // // // // // // //                         style: {
// // // // // // // //                             backgroundColor: '#C38F51',
// // // // // // // //                             height: '3px',
// // // // // // // //                         },
// // // // // // // //                     }}
// // // // // // // //                 >
// // // // // // // //                     {Object.keys(tabData).map((tab, index) => (
// // // // // // // //                         <Tab
// // // // // // // //                             key={tab}
// // // // // // // //                             label={tab}
// // // // // // // //                             sx={{
// // // // // // // //                                 fontSize: "16px",
// // // // // // // //                                 color: activeTab === index ? '#C38F51' : 'black',
// // // // // // // //                                 textTransform: 'none',
// // // // // // // //                                 fontWeight: activeTab === index ? 'bold' : 'normal',
// // // // // // // //                                 borderBottom: activeTab === index ? '3px solid #C38F51' : 'none',
// // // // // // // //                                 '&:hover': { color: '#C38F51' },
// // // // // // // //                             }}
// // // // // // // //                         />
// // // // // // // //                     ))}
// // // // // // // //                 </Tabs>
// // // // // // // //             </Box>

// // // // // // // //             <Box sx={{ py: 2 }}>
// // // // // // // //                 {Object.keys(tabData).map((tab, index) =>
// // // // // // // //                     index === activeTab ? (
// // // // // // // //                         <div key={tab}>
// // // // // // // //                             {/* Add a title row */}
// // // // // // // //                             <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
// // // // // // // //                                 <h4>Permissions</h4>
// // // // // // // //                                 <Box style={{ display: "flex", gap: "10px" }}>
// // // // // // // //                                     {["Add", "Edit", "Delete", "View"].map((action) => (
// // // // // // // //                                         <strong key={action}>{action}</strong>
// // // // // // // //                                     ))}
// // // // // // // //                                 </Box>
// // // // // // // //                             </div>
// // // // // // // //                             {/* List the tab data */}
// // // // // // // //                             {tabData[tab].map((list) => (
// // // // // // // //                                 <div key={list} style={{ display: "flex", justifyContent: "space-between" }}>
// // // // // // // //                                     <h4>{list}</h4>
// // // // // // // //                                     <Box>
// // // // // // // //                                         {["add", "edit", "delete", "view"].map((action) => (
// // // // // // // //                                             <label key={action} style={{ marginRight: "10px" }}>
// // // // // // // //                                                 <Field
// // // // // // // //                                                     type="checkbox"
// // // // // // // //                                                     name={`permissions.${tab}.${list}.${action}`}
// // // // // // // //                                                 />
// // // // // // // //                                             </label>
// // // // // // // //                                         ))}
// // // // // // // //                                     </Box>
// // // // // // // //                                 </div>
// // // // // // // //                             ))}
// // // // // // // //                         </div>
// // // // // // // //                     ) : null
// // // // // // // //                 )}
// // // // // // // //             </Box>

// // // // // // // //         </div >
// // // // // // // //     );
// // // // // // // // };

// // // // // // // // export default UserRoleTab;

// // // // import React, { useState } from 'react';
// // // // import Tabs from '@mui/material/Tabs';
// // // // import Tab from '@mui/material/Tab';
// // // // import Box from '@mui/material/Box';
// // // // import { Field } from 'formik';
// // // // import Grid from '@mui/material/Grid';  // Import Grid from MUI

// // // // const tabData = {
// // // //     Dashboard: ["Dashboard"],
// // // //     OperatorRegistration: ["All User List", "Purchaser List", "Referrer List", "Financial Consultant List"],
// // // //     SchemeManagement: ["Gold Stake Schemes", "Referral Schemes"],
// // // //     ContentManagement: ["Home", "Stake Now", "About Us", "Blog", "Contact Us"],
// // // // };

// // // // const UserRoleTab = ({ values, setFieldValue }) => {
// // // //     const [activeTab, setActiveTab] = useState(0);

// // // //     const handleTabChange = (event, newValue) => {
// // // //         setActiveTab(newValue);
// // // //     };

// // // //     return (
// // // //         <div>
// // // //             <Box
// // // //                 sx={{
// // // //                     maxWidth: { xs: 320, sm: "100%", md: "100%" },
// // // //                     boxShadow: 2,
// // // //                     bgcolor: 'background.paper',
// // // //                     color: "#C38F51",
// // // //                 }}
// // // //             >
// // // //                 <Tabs
// // // //                     value={activeTab}
// // // //                     onChange={handleTabChange}
// // // //                     variant="scrollable"
// // // //                     scrollButtons
// // // //                     allowScrollButtonsMobile
// // // //                     aria-label="user role tabs"
// // // //                     sx={{
// // // //                         '.MuiButtonBase-root-MuiTab-root.Mui-selected': { color: "#C38F51" },
// // // //                     }}
// // // //                     TabIndicatorProps={{
// // // //                         style: {
// // // //                             backgroundColor: '#C38F51',
// // // //                             height: '3px',
// // // //                         },
// // // //                     }}
// // // //                 >
// // // //                     {Object.keys(tabData).map((tab, index) => (
// // // //                         <Tab
// // // //                             key={tab}
// // // //                             label={tab}
// // // //                             sx={{
// // // //                                 fontSize: "16px",
// // // //                                 color: activeTab === index ? '#C38F51' : 'black',
// // // //                                 textTransform: 'none',
// // // //                                 fontWeight: activeTab === index ? 'bold' : 'normal',
// // // //                                 borderBottom: activeTab === index ? '3px solid #C38F51' : 'none',
// // // //                                 '&:hover': { color: '#C38F51' },
// // // //                             }}
// // // //                         />
// // // //                     ))}
// // // //                 </Tabs>
// // // //             </Box>

// // // //             <Box sx={{ py: 2 }}>
// // // //                 {Object.keys(tabData).map((tab, index) =>
// // // //                     index === activeTab ? (
// // // //                         <div key={tab}>
// // // //                             {/* Title Row using Grid */}
// // // //                             <Grid container justifyContent="space-between" alignItems="center" mb={2}>
// // // //                                 <Grid item xs={6}>
// // // //                                     <h4>Permissions</h4>
// // // //                                 </Grid>
// // // //                                 <Grid item xs={6}>
// // // //                                     <Box style={{ display: "flex", justifyContent:"space-between" }}>
// // // //                                         {["Add", "Edit", "Delete", "View"].map((action) => (
// // // //                                             <strong key={action}>{action}</strong>
// // // //                                         ))}
// // // //                                     </Box>
// // // //                                 </Grid>
// // // //                             </Grid>

// // // //                             {/* List the tab data with grid layout */}
// // // //                             {tabData[tab].map((list) => (
// // // //                                 <Grid container key={list} justifyContent="space-between" alignItems="center" mb={1}>
// // // //                                     <Grid item xs={6}>
// // // //                                         <h4>{list}</h4>
// // // //                                     </Grid>
// // // //                                     <Grid item xs={6}>
// // // //                                         <Box sx={{display:"flex",justifyContent:"space-between"}}>
// // // //                                             {["add", "edit", "delete", "view"].map((action) => (
// // // //                                                 <label key={action} style={{ marginRight: "10px" }}>
// // // //                                                     <Field
// // // //                                                         type="checkbox"
// // // //                                                         name={`permissions.${tab}.${list}.${action}`}
// // // //                                                     />
// // // //                                                 </label>
// // // //                                             ))}
// // // //                                         </Box>
// // // //                                     </Grid>
// // // //                                 </Grid>
// // // //                             ))}
// // // //                         </div>
// // // //                     ) : null
// // // //                 )}
// // // //             </Box>
// // // //         </div>
// // // //     );
// // // // };

// // // // export default UserRoleTab;

// // // // // ......................................................................

// // import React, { useState } from "react";
// // import Tabs from "@mui/material/Tabs";
// // import Tab from "@mui/material/Tab";
// // import Box from "@mui/material/Box";
// // import { Field } from "formik";
// // import Grid from "@mui/material/Grid";

// // const tabData = {
// //     Dashboard: ["Dashboard"],
// //     OperatorRegistration: ["All User List", "Purchaser List", "Referrer List", "Financial Consultant List"],
// //     SchemeManagement: ["Gold Stake Schemes", "Referral Schemes"],
// //     ContentManagement: ["Home", "Stake Now", "About Us", "Blog", "Contact Us"],
// // };

// // const UserRoleTab = ({ values, setFieldValue }) => {
// //     const [activeTab, setActiveTab] = useState(0);

// //     const handleTabChange = (event, newValue) => {
// //         setActiveTab(newValue);
// //     };

// //     return (
// //         <div>
// //             <Box
// //                 sx={{
// //                     maxWidth: { xs: 320, sm: "100%", md: "100%" },
// //                     boxShadow: 2,
// //                     bgcolor: "background.paper",
// //                     color: "#C38F51",
// //                 }}
// //             >
// //                 <Tabs
// //                     value={activeTab}
// //                     onChange={handleTabChange}
// //                     variant="scrollable"
// //                     scrollButtons
// //                     allowScrollButtonsMobile
// //                     aria-label="user role tabs"
// //                     TabIndicatorProps={{ style: { backgroundColor: "#C38F51", height: "3px" } }}
// //                 >
// //                     {Object.keys(tabData).map((tab, index) => (
// //                         <Tab key={tab} label={tab} />
// //                     ))}
// //                 </Tabs>
// //             </Box>

// //             <Box sx={{ py: 2 }}>
// //                 {Object.keys(tabData).map((tab, index) =>
// //                     index === activeTab ? (
// //                         <div key={tab}>
// //                             <Grid container justifyContent="space-between" alignItems="center" mb={2}>
// //                                 <Grid item xs={6}>
// //                                     <h4>Permissions</h4>
// //                                 </Grid>
// //                                 <Grid item xs={6}>
// //                                     <Box style={{ display: "flex", justifyContent: "space-between" }}>
// //                                         {["Add", "Edit", "Delete", "View"].map((action) => (
// //                                             <strong key={action}>{action}</strong>
// //                                         ))}
// //                                     </Box>
// //                                 </Grid>
// //                             </Grid>

// //                             {tabData[tab].map((list) => (
// //                                 <Grid container key={list} justifyContent="space-between" alignItems="center" mb={1}>
// //                                     <Grid item xs={6}>
// //                                         <h4>{list}</h4>
// //                                     </Grid>
// //                                     <Grid item xs={6}>
// //                                         <Box sx={{ display: "flex", justifyContent: "space-between" }}>
// //                                             {["add", "edit", "delete", "view"].map((action) => (
// //                                                 <label key={action} style={{ marginRight: "10px" }}>
// //                                                     <Field type="checkbox" name={`permissions.${tab}.${list}.${action}`} />
// //                                                 </label>
// //                                             ))}
// //                                         </Box>
// //                                     </Grid>
// //                                 </Grid>
// //                             ))}
// //                         </div>
// //                     ) : null
// //                 )}
// //             </Box>
// //         </div>
// //     );
// // };

// // export default UserRoleTab;

// import React, { useState } from "react";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
// import Box from "@mui/material/Box";
// import Grid from "@mui/material/Grid";
// import { Typography } from "@mui/material";

// const tabData = {
//   Dashboard: ["Dashboard"],
//   OperatorRegistration: [
//     "All User List",
//     "Purchaser List",
//     "Referrer List",
//     "Financial Consultant List",
//   ],
//   SchemeManagement: ["Gold Stake Schemes", "Referral Schemes"],
//   ContentManagement: ["Home", "Stake Now", "About Us", "Blog", "Contact Us"],
// };

// const UserRoleTab = ({ values, setFieldValue }) => {
//   const [activeTab, setActiveTab] = useState(0);

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//   };

//   const handleCheckboxChange =
//     (category, subCategory, action, tab) => (event) => {
//       console.log(category, "category");
//       console.log(subCategory, "subCategory");

//       console.log(action, "action");
//       console.log(
//         `permissions.${category}.${subCategory}.${action}`,
//         "tabbbbbb"
//       );

//       setFieldValue(
//         `permissions.${category}.${subCategory}.${action}`,
//         event.target.checked
//       );
//     };

//   return (
//     <div>
//       <Box
//         sx={{
//           maxWidth: { xs: 320, sm: "100%", md: "100%" },
//           boxShadow: 2,
//           bgcolor: "background.paper",
//           color: "#C38F51",
//         }}
//       >
//         <Tabs
//           value={activeTab}
//           onChange={handleTabChange}
//           variant="scrollable"
//           scrollButtons
//           allowScrollButtonsMobile
//           aria-label="user role tabs"
//           TabIndicatorProps={{
//             style: { backgroundColor: "#C38F51", height: "3px" },
//           }}
//         >
//           {Object.keys(tabData).map((tab, index) => (
//             <Tab
//               key={tab}
//               label={
//                 <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     gap: 1,
//                   }}
//                 >
//                   {/* {tab.icon} */}
//                   {tab}
//                 </Box>
//               }
//               sx={{
//                 fontSize: "16px",
//                 color: activeTab === index ? "#C38F51" : "gray",
//                 textTransform: "none",
//                 fontWeight: activeTab === index ? "bold" : "normal",
//                 borderBottom:
//                   activeTab === index ? "3px solid #C38F51" : "none",
//                 "&.Mui-selected": {
//                   color: "#C38F51",
//                 },
//                 "&:hover": {
//                   color: "#C38F51",
//                 },
//               }}
//             />
//             // <Tab key={tab} label={tab} color="red" />
//           ))}
//         </Tabs>
//       </Box>

//       <Box sx={{ py: 2 }}>
//         {Object.keys(tabData).map((tab, index) =>
//           index === activeTab ? (
//             <div key={tab}>
//               <Grid
//                 container
//                 justifyContent="space-between"
//                 alignItems="center"
//                 // mb={2}
//               >
//                 <Grid item xs={6}>
//                   <h4>Permissions</h4>
//                 </Grid>
//                 <Grid item xs={6}>
//                   <Box
//                     style={{ display: "flex", justifyContent: "space-between" }}
//                   >
//                     {["Add", "Edit", "Delete", "View"].map((action) => (
//                       <strong key={action}>{action}</strong>
//                     ))}
//                   </Box>
//                 </Grid>
//               </Grid>

//               {tabData[tab].map((list) => (
//                 <Grid
//                   container
//                   key={list}
//                   justifyContent="space-between"
//                   alignItems="center"
//                   mb={1}
//                 >
//                   <Grid item xs={6}>
//                     <Typography variant="body1" sx={{ color: "#C38F51" }}>
//                       {list}
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={6}>
//                     <Box
//                       sx={{ display: "flex", justifyContent: "space-between" }}
//                     >
//                       {["add", "edit", "delete", "view"].map((action) => (
//                         <label
//                           key={action}
//                           style={{ marginRight: "10px", color: "red" }}
//                         >
//                           {/* <input
//                                                         type="checkbox"
//                                                         checked={values.permissions[tab]?.[list]?.[action]}
//                                                         onChange={handleCheckboxChange(tab, list, action,tab)}
//                                                     /> */}
//                           <input
//                             type="checkbox"
//                             name={`permissions.${tab}.${list}.${action}`}
//                             checked={
//                               values.permissions?.[tab]?.[list]?.[action] ||
//                               false
//                             }
//                             style={{
//                               accentColor: "rgb(175 120 55)", // Change tick color
//                               width: "17px", // Increase width
//                               height: "17px", // Increase height
//                             }}
//                             onChange={handleCheckboxChange(tab, list, action)}
//                           />
//                         </label>
//                       ))}
//                     </Box>
//                   </Grid>
//                 </Grid>
//               ))}
//             </div>
//           ) : null
//         )}
//       </Box>
//     </div>
//   );
// };

// export default UserRoleTab;

// // // // // .....................................................

// // import React, { useState } from "react";
// // import Tabs from "@mui/material/Tabs";
// // import Tab from "@mui/material/Tab";
// // import Box from "@mui/material/Box";
// // import { Field } from "formik";
// // import Grid from "@mui/material/Grid";

// // const tabData = {
// //     Dashboard: ["Dashboard"],
// //     OperatorRegistration: ["All User List", "Purchaser List", "Referrer List", "Financial Consultant List"],
// //     SchemeManagement: ["Gold Stake Schemes", "Referral Schemes"],
// //     ContentManagement: [
// //         { "Home": ["Banner", "Offer", "3 steps", "Faqs"] },
// //         { "Stake Now": ["Banner", "Offer"] },
// //         { "About Us": ["Banner", "3 steps", "Faqs"] },
// //         { "Blog": ["Faqs"] },
// //         { "Contact Us": ["3 steps", "Faqs"] }
// //     ],
// // };

// // const UserRoleTab = ({ values, setFieldValue }) => {
// //     const [activeTab, setActiveTab] = useState(0);

// //     const handleTabChange = (event, newValue) => {
// //         setActiveTab(newValue);
// //     };

// //     return (
// //         <div>
// //             <Box
// //                 sx={{
// //                     maxWidth: { xs: 320, sm: "100%", md: "100%" },
// //                     boxShadow: 2,
// //                     bgcolor: "background.paper",
// //                     color: "#C38F51",
// //                 }}
// //             >
// //                 <Tabs
// //                     value={activeTab}
// //                     onChange={handleTabChange}
// //                     variant="scrollable"
// //                     scrollButtons
// //                     allowScrollButtonsMobile
// //                     aria-label="user role tabs"
// //                     TabIndicatorProps={{ style: { backgroundColor: "#C38F51", height: "3px" } }}
// //                 >
// //                     {Object.keys(tabData).map((tab, index) => (
// //                         <Tab key={tab} label={tab} />
// //                     ))}
// //                 </Tabs>
// //             </Box>

// //             <Box sx={{ py: 2 }}>
// //                 {Object.keys(tabData).map((tab, index) =>
// //                     index === activeTab ? (
// //                         <div key={tab}>
// //                             <Grid container justifyContent="space-between" alignItems="center" mb={2}>
// //                                 <Grid item xs={6}>
// //                                     <h4>Permissions</h4>
// //                                 </Grid>
// //                                 <Grid item xs={6}>
// //                                     <Box style={{ display: "flex", justifyContent: "space-between" }}>
// //                                         {["Add", "Edit", "Delete", "View"].map((action) => (
// //                                             <strong key={action}>{action}</strong>
// //                                         ))}
// //                                     </Box>
// //                                 </Grid>
// //                             </Grid>

// //                             {tabData[tab].map((item, idx) => {
// //                                 if (typeof item === "string") {
// //                                     // Regular list items
// //                                     return (
// //                                         <Grid container key={idx} justifyContent="space-between" alignItems="center" mb={1}>
// //                                             <Grid item xs={6}>
// //                                                 <h4>{item}</h4>
// //                                             </Grid>
// //                                             <Grid item xs={6}>
// //                                                 <Box sx={{ display: "flex", justifyContent: "space-between" }}>
// //                                                     {["add", "edit", "delete", "view"].map((action) => (
// //                                                         <label key={action} style={{ marginRight: "10px" }}>
// //                                                             <Field type="checkbox" name={`permissions.${tab}.${item}.${action}`} />
// //                                                         </label>
// //                                                     ))}
// //                                                 </Box>
// //                                             </Grid>
// //                                         </Grid>
// //                                     );
// //                                 } else if (typeof item === "object") {
// //                                     // Render subcategories
// //                                     return Object.keys(item).map((subheading, subIdx) => (
// //                                         <div key={subIdx} style={{ marginTop: "10px" }}>
// //                                             <h3 style={{ color: "#C38F51", marginBottom: "5px" }}>{subheading}</h3>
// //                                             {item[subheading].map((subItem, subItemIdx) => (
// //                                                 <Grid container key={subItemIdx} justifyContent="space-between" alignItems="center" mb={1}>
// //                                                     <Grid item xs={6}>
// //                                                         <h4>{subItem}</h4>
// //                                                     </Grid>
// //                                                     <Grid item xs={6}>
// //                                                         <Box sx={{ display: "flex", justifyContent: "space-between" }}>
// //                                                             {["add", "edit", "delete", "view"].map((action) => (
// //                                                                 <label key={action} style={{ marginRight: "10px" }}>
// //                                                                     <Field type="checkbox" name={`permissions.${tab}.${subheading}.${subItem}.${action}`} />
// //                                                                 </label>
// //                                                             ))}
// //                                                         </Box>
// //                                                     </Grid>
// //                                                 </Grid>
// //                                             ))}
// //                                         </div>
// //                                     ));
// //                                 }
// //                             })}
// //                         </div>
// //                     ) : null
// //                 )}
// //             </Box>
// //         </div>
// //     );
// // };

// // export default UserRoleTab;




import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";

const tabData = {
  Dashboard: ["Dashboard"],
  OperatorRegistration: [
    "All User List",
    "Purchaser List",
    "Referrer List",
    "Financial Consultant List",
  ],
  // SchemeManagement: ["Gold Stake Schemes", "Referral Schemes"],
  SchemeManagement: ["Gold Stake Schemes"],

  ContentManagement: ["Home", "Stake Now","Referrals", "About Us", "Blog", "Contact Us"],
};

// Define which permissions should be disabled dynamically
const disabledPermissions = {
  Dashboard: { Dashboard: ["add", "delete", "edit"] }, // Disable Add & Delete for Dashboard
  OperatorRegistration: {
    "All User List": ["edit", "delete"],
    "Purchaser List": ["edit", "delete", "add"],
    "Referrer List": ["edit", "delete", "add"],
    "Financial Consultant List": ["edit", "delete"],
    
  },  // Disable Edit & View for Operator Registration
  // SchemeManagement: {
  //   // "Gold Stake Schemes": ["view"],
  //   "Referral Schemes": ["delete"]
  // },

  // ContentManagement: {
  //   Home: ["add", "delete"],
  //   Blog: ["edit"],
  // }

  // Add more sections & permissions dynamically as needed
};

const UserRoleTab = ({ values, setFieldValue }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleCheckboxChange = (category, subCategory, action) => (event) => {
    setFieldValue(
      `permissions.${category}.${subCategory}.${action}`,
      event.target.checked
    );
  };

  return (
    <div>
      <Box
        sx={{
          maxWidth: { xs: 320, sm: "100%", md: "100%" },
          boxShadow: 2,
          bgcolor: "background.paper",
          color: "#C38F51",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          aria-label="user role tabs"
          TabIndicatorProps={{
            style: { backgroundColor: "#C38F51", height: "3px" },
          }}
        >
          {Object.keys(tabData).map((tab, index) => (
            <Tab
              key={tab}
              label={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                  }}
                >
                  {tab}
                </Box>
              }
              sx={{
                fontSize: "16px",
                color: activeTab === index ? "#C38F51" : "gray",
                textTransform: "none",
                fontWeight: activeTab === index ? "bold" : "normal",
                borderBottom:
                  activeTab === index ? "3px solid #C38F51" : "none",
                "&.Mui-selected": {
                  color: "#C38F51",
                },
                "&:hover": {
                  color: "#C38F51",
                },
              }}
            />
          ))}
        </Tabs>
      </Box>

      <Box sx={{ py: 2 }}>
        {Object.keys(tabData).map((tab, index) =>
          index === activeTab ? (
            <div key={tab}>
              <Grid container justifyContent="space-between" alignItems="center">
                <Grid item xs={6}>
                  <h4>Permissions</h4>
                </Grid>
                <Grid item xs={6}>
                  <Box
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {["Add", "Edit", "Delete", "View"].map((action) => (
                      <strong key={action}>{action}</strong>
                    ))}
                  </Box>
                </Grid>
              </Grid>

              {tabData[tab].map((list) => (
                <Grid
                  container
                  key={list}
                  justifyContent="space-between"
                  alignItems="center"
                  mb={1}
                >
                  <Grid item xs={6}>
                    <Typography variant="body1" sx={{ color: "#C38F51" }}>
                      {list}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      {["add", "edit", "delete", "view"].map((action) => (
                        <label
                          key={action}
                          style={{ marginRight: "10px", color: "red" }}
                        >
                          <input
                            type="checkbox"
                            name={`permissions.${tab}.${list}.${action}`}
                            checked={
                              values.permissions?.[tab]?.[list]?.[action] ||
                              false
                            }
                            // disabled={disabledPermissions[tab]?.includes(
                            //   action
                            // )} // Dynamically disable based on configuration

                            disabled={
                              disabledPermissions[tab]?.[list]?.includes(action) || false
                            }

                            style={{
                              accentColor: "rgb(175 120 55)", // Change tick color
                              width: "17px", // Increase width
                              height: "17px", // Increase height
                            }}
                            onChange={handleCheckboxChange(tab, list, action)}
                          />
                        </label>
                      ))}
                    </Box>
                  </Grid>
                </Grid>
              ))}
            </div>
          ) : null
        )}
      </Box>
    </div>
  );
};

export default UserRoleTab;
